import * as React from 'react';

import { Grid, Link, Spacer, Typography } from '@emburse/ui-core';

import { AbaToastContainer } from '@ReactComponents/AbaToastContainer';
import { EmburseAccountsLeftContentContainer } from '@ReactComponents/Shared/Account/EmburseAccountsLeftContentContainer';
import { EmburseAccountsPageContainer } from '@ReactComponents/Shared/Account/EmburseAccountsPageContainer';

import { RedesignedResetPasswordForm } from './RedesignedResetPasswordForm';

export interface IExtendedWindow extends Window {
  featureFlags: any;
  csrf: any;
  locals: any;
  email?: string;
}

export const RedesignedResetPasswordPage: React.FC<{
  csrf: string;
  email?: string;
  success?: boolean;
  error?: string;
}> = ({ csrf, email, success, error }) => {
  let alertSeverity: 'success' | 'error' | undefined;
  let alertTitle: string | undefined;
  if (success) {
    alertSeverity = 'success';
    alertTitle = `We've sent a recovery link to you at ${email}`;
  } else if (error) {
    alertSeverity = 'error';
    alertTitle = error;
  }

  return (
    <div className="onboardingWrapper">
      <EmburseAccountsPageContainer>
        <EmburseAccountsLeftContentContainer
          title="Forgot password?"
          alertProps={alertSeverity ? { severity: alertSeverity, alertTitle } : undefined}
        >
          <Spacer size={16} />
          <Grid item>
            <Typography>A recovery email will be sent shortly with instructions to create a new password.</Typography>
          </Grid>
          <Spacer size={16} />
          <Grid item>
            <RedesignedResetPasswordForm csrf={csrf} initialEmail={email} />
          </Grid>
          <Spacer size={16} />
          <Grid item>
            <Link color="textPrimary" href="/login">
              Back to login
            </Link>
          </Grid>
        </EmburseAccountsLeftContentContainer>
      </EmburseAccountsPageContainer>
      <AbaToastContainer />
    </div>
  );
};
